import type { CSSProperties } from 'preact'

import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { CookieTable } from '#src/assets/ui/overview/components/CookieTable.tsx'
import { getCookieControllerGroups } from '#src/assets/ui/overview/lib/getCookieControllerGroups.ts'
import { privacyLinkStyle } from '#src/assets/ui/shared/styles.ts'
import type { CookieRecord } from '#src/services/cookieTranslationService/types.ts'

export function CookieControllerList({
  cookies,
  fallbackDomain,
  t,
}: {
  cookies: CookieRecord[]
  fallbackDomain: string
  t: CookieConsentTranslator
}) {
  const groups = getCookieControllerGroups(cookies)

  return (
    <ul style={listStyle}>
      {groups.map(group => (
        <li key={group.dataController} style={itemStyle}>
          <h4>{group.dataController}</h4>
          {group.privacyLink ? (
            <a
              href={group.privacyLink}
              target="_blank"
              rel="noopener noreferrer"
              style={privacyLinkStyle}
            >
              {t('readCookieProviderPrivacyPolicy')}
            </a>
          ) : null}
          <CookieTable
            cookies={group.cookies}
            fallbackDomain={fallbackDomain}
            t={t}
          />
        </li>
      ))}
    </ul>
  )
}

const listStyle: CSSProperties = {
  listStyle: 'none',
  padding: '0',
  margin: '0',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  maxWidth: '100%',
  minWidth: '0',
}

const itemStyle: CSSProperties = {
  maxWidth: '100%',
  minWidth: '0',
}
